const universities: string[] = [
  "University of Moratuwa",
  "Sri Lanka Technological Campus - SLTC",
  "University of Peradeniya",
  "Information Institute of Technology - IIT",
  "Sri Lanka Institute of Information Technology - SLIIT",
  "Vavuniya Campus of University of Jaffna",
  "University of Jaffna",
  "National School of Business Management - NSBM",
  "Rajarata University of Sri Lanka",
  "University of Colombo School of Computing - UCSC",
  "University of Kelaniya",
  "General Sir John Kotelawala Defense University - KDU",
  "University of Sri Jayewardenepura",
  "University of Vocational Technology - UniVoTec",
  "Open University of Sri Lanka",
  "University of Ruhuna",
  "Wayamba University of Sri Lanka",
  "Sabaragamuwa University of Sri Lanka",
  "Uva Wellassa University",
  "Other",
];

export default universities;
